import { alpha } from "@mui/system/colorManipulator";
import FernBackgroundImage from "../assets/background_fern.png";

export const sidebarColor = {
  sidebarBgColor: "#313541",
  sidebarHeaderColor: "#313541",
  sidebarTextColor: "#fff",
  sidebarMenuSelectedBgColor: alpha("#ff7e21", 0.8),
  sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
};

export const fontColor = {
  titleFontColor: "#4a4949",
  subTitleFontColor: "#828181",
  orangeTitle: "#ff7e21",
  orangeBackground: alpha("#ff7e21", 0.25),
  orangeSelectedBackground: alpha("#ff7e21", 0.2),
  orangeUnReadAlertBackground: alpha("#ff7e21", 0.1),
  orangeHoverBackground: alpha("#ff7e21", 0.15),
  orangeHoverRipple: "#fd933ab3 !important",
  grayBackground: "#e8e8e8",
  overdueBackground: "#ffe2e2ff",
  unrespondedBackground: "#f7d5bdff",
  grayTabBackground: "#f0f0f0ff",
  warningFontColor: "#814747ff",
  footerVersion: "#555657",
  footerAccountText: "#c2c2c2",
  footerAccountBackground: "#545b70",
  roleAccessibleBorder: "#47fc5c",
  roleAccessibleBackground: "#ebfced",
  ruleBeforeAccessible: "#00d615",
  ruleBeforeInaccessible: "gray",
  ruleSearchEmptyResultBackground: "#f7f7f7",
  searchedTextBackground: "#e8bb49",
  blueHighlight: alpha("#0000FF", 0.15),
  redFontColor: "#ff2a25",
  ruleOfWeekBackground: `linear-gradient(to right,rgb(253, 132, 45),rgb(254, 139, 56)), url(${FernBackgroundImage})`,
  ruleOfWeekSelected: `linear-gradient(to right,rgb(255, 119, 22),rgb(253, 117, 21)), url(${FernBackgroundImage})`,
  ruleOfWeekHover: `linear-gradient(to right,rgb(252, 130, 42),rgb(253, 117, 21)), url(${FernBackgroundImage})`,
  ruleOfWeekSubTitle: "#ededed",
};
